var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2597_2542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2597_2542)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2597_2542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2597_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8601 20.423V21.997H18.3483V20.9491H20.125V21.997H20.6129V20.4258L17.8601 20.423ZM18.2939 19.9139H20.171C20.4317 19.8603 20.6256 19.6224 20.6803 19.3923H17.7846C17.8388 19.6225 18.0355 19.8603 18.2939 19.9139ZM16.3816 21.998C16.6277 21.8901 16.7601 21.7035 16.8108 21.4852H14.6213L14.6227 19.3935L14.1319 19.395V21.998H16.3816ZM10.4819 19.9069H12.2155C12.4769 19.8283 12.6963 19.6225 12.7498 19.3943H9.99595V20.9326H12.2499V21.4724L10.4819 21.4738C10.2049 21.5537 9.9699 21.7461 9.8527 22.0001L9.99595 21.9974H12.7342V20.4211H10.4819V19.9069ZM6.20221 19.9118H8.07872C8.3398 19.858 8.53384 19.6203 8.58823 19.39H5.69269C5.74674 19.6203 5.94363 19.858 6.20221 19.9118ZM6.20221 20.9406H8.07872C8.3398 20.8874 8.53384 20.6495 8.58823 20.419H5.69269C5.74674 20.6495 5.94363 20.8874 6.20221 20.9406ZM6.20221 21.9978H8.07872C8.3398 21.9441 8.53384 21.7063 8.58823 21.476H5.69269C5.74674 21.7063 5.94363 21.9441 6.20221 21.9978ZM1.32031 19.3963C1.37672 19.6238 1.56722 19.8563 1.82857 19.9145H2.61847L2.65877 19.931V21.9919H3.15202V19.931L3.19683 19.9145H3.98743C4.2517 19.8441 4.43809 19.6238 4.49353 19.3963V19.3912H1.32031V19.3963Z",
    fill: "#E82127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0011 16.8369L13.4657 3.53298C15.8149 3.53298 16.5559 3.78023 16.6629 4.78944C16.6629 4.78944 18.2388 4.22546 19.0337 3.08003C15.932 1.70055 12.8155 1.63833 12.8155 1.63833L10.997 3.76423L11.0011 3.76396L9.18262 1.638C9.18262 1.638 6.06609 1.70028 2.96484 3.07976C3.75898 4.22519 5.33552 4.78917 5.33552 4.78917C5.44313 3.7799 6.18322 3.53265 8.51666 3.53105L11.0011 16.8369Z",
    fill: "#E82127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 1.02433C13.5072 1.00593 16.377 1.3966 19.3149 2.62559C19.7075 1.94725 19.8085 1.64746 19.8085 1.64746C16.597 0.427942 13.5895 0.0105909 10.9996 0.00012207C8.40988 0.0105909 5.40249 0.428009 2.19141 1.64746C2.19141 1.64746 2.33466 2.01673 2.68466 2.62559C5.62195 1.3966 8.49227 1.00593 10.9996 1.02433H10.9999Z",
    fill: "#E82127"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.08a98ad678366bbb4918a03665d04af4.svg";
export { ForwardRef as ReactComponent };